import {
    B2B_CLIENTS_PREFIX,
    B2B_ORDERS_PREFIX,
    B2B_SUPPLIERS_PREFIX,
    CAMPAIGNS_PREFIX,
    CAMPAIGNS_TABS,
    CLIENTS_TABS,
    LOYALTY_PREFIX,
    LOYALTY_TABS,
    ORDERS_TABS,
    RETAIL_CLIENTS_PREFIX,
    RETAIL_FREQUENCY_PREFIX,
    RETAIL_FREQUENCY_TABS,
    SUPPLIERS_TABS,
    WAREHOUSE_ORDERS_PREFIX,
    allScreenTabCodes,
    screenRouteAccessCodes,
} from "./screenTabPermissions";

/** Retail + B2B клиенти (споделен /clients). */
export function clientsRouteAccessCodes(): string[] {
    return [
        ...screenRouteAccessCodes(RETAIL_CLIENTS_PREFIX, CLIENTS_TABS, ["clients.view", "clients.manage"]),
        ...screenRouteAccessCodes(B2B_CLIENTS_PREFIX, CLIENTS_TABS),
    ];
}

/** B2B + warehouse поръчки (споделен /orders). */
export function ordersRouteAccessCodes(): string[] {
    return [
        ...screenRouteAccessCodes(B2B_ORDERS_PREFIX, ORDERS_TABS, ["orders.view", "orders.manage"]),
        ...screenRouteAccessCodes(WAREHOUSE_ORDERS_PREFIX, ORDERS_TABS),
    ];
}

export function loyaltyRouteAccessCodes(): string[] {
    return screenRouteAccessCodes(LOYALTY_PREFIX, LOYALTY_TABS);
}

export function frequencyRouteAccessCodes(): string[] {
    return screenRouteAccessCodes(RETAIL_FREQUENCY_PREFIX, RETAIL_FREQUENCY_TABS);
}

export function suppliersRouteAccessCodes(): string[] {
    return [
        ...screenRouteAccessCodes(B2B_SUPPLIERS_PREFIX, SUPPLIERS_TABS),
        "b2b.view",
    ];
}

export function campaignsRouteAccessCodes(): string[] {
    return screenRouteAccessCodes(CAMPAIGNS_PREFIX, CAMPAIGNS_TABS, ["reports.view", "dashboard.management"]);
}

export function expensesTransportAccessCodes(): string[] {
    return [
        "expenses.transport.view",
        "expenses.transport.manage",
        "expenses.view",
        "expenses.manage",
        "reports.view",
        "dashboard.management",
    ];
}

export function expensesMarketingAccessCodes(): string[] {
    return [
        "expenses.marketing.view",
        "expenses.marketing.manage",
        "expenses.view",
        "expenses.manage",
        "reports.view",
        "dashboard.management",
    ];
}

export function expensesSalariesAccessCodes(): string[] {
    return [
        "expenses.salaries.view",
        "expenses.salaries.manage",
        "expenses.view",
        "expenses.manage",
        "reports.view",
        "dashboard.management",
    ];
}

export function expensesAnyAccessCodes(): string[] {
    return Array.from(new Set([
        ...expensesTransportAccessCodes(),
        ...expensesMarketingAccessCodes(),
        ...expensesSalariesAccessCodes(),
    ]));
}

export function allNavTabOptInCodes(): string[] {
    return [
        ...allScreenTabCodes(RETAIL_FREQUENCY_PREFIX, RETAIL_FREQUENCY_TABS),
        ...allScreenTabCodes(LOYALTY_PREFIX, LOYALTY_TABS),
        ...allScreenTabCodes(RETAIL_CLIENTS_PREFIX, CLIENTS_TABS),
        ...allScreenTabCodes(B2B_CLIENTS_PREFIX, CLIENTS_TABS),
        ...allScreenTabCodes(B2B_SUPPLIERS_PREFIX, SUPPLIERS_TABS),
        ...allScreenTabCodes(CAMPAIGNS_PREFIX, CAMPAIGNS_TABS),
        ...allScreenTabCodes(B2B_ORDERS_PREFIX, ORDERS_TABS),
        ...allScreenTabCodes(WAREHOUSE_ORDERS_PREFIX, ORDERS_TABS),
    ];
}
